import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import ApiService from "@/api/ApiService";
import { OrderHistoryDialog as HistoryDialog, type OrderHistoryEntry } from "@/shared/plant/OrderHistoryDialog";

export default function ExternalOrderHistoryDialog({ orderId, close }: { orderId: number | string; close: () => void }) {
  const query = useQuery<OrderHistoryEntry[], AxiosResponse>({
    queryKey: ["getExternalOrderHistory", String(orderId)],
    enabled: !!orderId,
    queryFn: ApiService.getExternalOrderHistory(String(orderId)),
    staleTime: 0,
  });
  return (
    <HistoryDialog
      open={!!orderId}
      entries={query.data ?? []}
      loading={query.isLoading || !orderId}
      error={query.isLoadingError ? "Error" : undefined}
      onClose={close}
    />
  );
}
